import _ from "underscore";
import { Topic } from "../index";
import { QuestionType } from "service/service";
import { StuTopics } from "service/homework";

export const getRightAnswerCount = (list: Topic[], type: string) => {
    let data = _.chain(list)
        .map(item => {
            return {
                state: item.answers.every(
                    item => item.isChoose === item.isRight
                ),
                score: parseFloat(item.score)
            };
        })
        .reduce(
            (memo, item) => {
                if (item.state) {
                    memo.count = memo.count + 1;
                    memo.score = memo.score + item.score;
                }
                return memo;
            },
            { count: 0, score: 0 }
        )
        .value();
    return data;
};

export const getCorrectState = (item: Topic, type: number) => {
    return item.answers.every(item => item.isChoose === item.isRight);
};

export const getGroupExamScore = (topics: StuTopics[], type: QuestionType) => {
    let score = 0,
        count: string | number = "-";
    switch (type) {
        case QuestionType.DanXuan:
        case QuestionType.DuoXuan:
        case QuestionType.PanDuan:
            let data = getRightAnswerCount(topics, type);
            score = data.score;
            count = data.count;
            break;
        case QuestionType.TianKong:
            count = "-";
            score = _.reduce(
                topics,
                (prev, topic) => {
                    return (
                        prev +
                        _.reduce(
                            topic.answers,
                            (prev, answer) => {
                                const content = answer.content?.replace(
                                    /\s*/g,
                                    ""
                                );
                                const stuAnswer = answer.stuAnswer?.replace(
                                    /\s*/g,
                                    ""
                                );
                                if (content === stuAnswer) {
                                    return (
                                        prev +
                                        parseFloat(topic.score) /
                                            topic.answers.length
                                    );
                                } else {
                                    return prev;
                                }
                            },
                            0
                        )
                    );
                },
                0
            );
            break;
        case QuestionType.ZhuGuan:
            count = "-";
            score = _.reduce(
                topics,
                (memo, item) =>
                    parseFloat(item.markScore)
                        ? memo + parseFloat(item.markScore)
                        : memo,
                0
            );
            break;
        case QuestionType.TingLi:
        case QuestionType.WanXingTianKong:
        case QuestionType.YueDuLiJie:
            count = "-";
            score = _.chain(topics)
                .map(topic => {
                    return _.chain(topic.topics)
                        .groupBy("type")
                        .map((topic, type) => {
                            return getGroupExamScore(
                                topic,
                                type as unknown as QuestionType
                            );
                        })
                        .reduce(
                            (prev, curr) =>
                                prev + ((curr.score as unknown as number) || 0),
                            0
                        )
                        .value();
                })
                .reduce((prev, curr) => prev + curr, 0)
                .value();
            break;
        default:
            break;
    }
    return { type, all: topics.length, correct: count, score };
};
